import { render, staticRenderFns } from "./update-registration.vue?vue&type=template&id=62e14e96&scoped=true&"
import script from "./update-registration.vue?vue&type=script&lang=js&"
export * from "./update-registration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e14e96",
  null
  
)

export default component.exports